module.exports = __webpack_public_path__ + "img/ylkt4-4.4df4df6b.jpg";